import styled from 'styled-components';

export const QuoteContainer = styled.div`
  padding: 16px;
  width: 100dvw;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const QuoteContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #f9faf9;
`;

export const QuoteTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuoteButton = styled.div`
  width: 100%;
  padding: 16px;
`;
